import gql from 'graphql-tag';

export const accountCountFragment = gql`
  fragment accountCountFragment on AccountCount {
    dokkioClass
    id
    collapsedIntegrationItemCount
    conversationCount
    integrationEmailCount
    webpageCount
    integrationCount
    totalReferralCount
    unredeemedReferralCount
  }
`;
export default accountCountFragment;
